<div class="group-popup">
  <div class="popup-box">
    <div class="login-box">
      <div *ngIf="errorNotification" class="alert alert-danger" role="alert">{{ messageNotification }}</div>
      <div class="ctent-login">
        <div class="f-login">
          <div class="logo">
            <a routerLink="/">
              <img src="assets/images/logo-big.png" alt="Hush City">
            </a>
          </div>
          <h2 class="txt-welcome">{{ 'Welcome' | translate }}</h2>
          <form (ngSubmit)="onLogin()" [formGroup]="formSignIn">
            <div class="field-input">
              <input type="text" id="username" formControlName="username" [placeholder]="'Email' | translate">
              <span>{{ 'Email' | translate }}</span>
              <p *ngIf="checkUsername" class="error-require">{{ messageCheckUsername }}</p>
            </div>
            <div class="field-input mb0">
              <input type="password" id="password" formControlName="password" [placeholder]="'Password' | translate">
              <span>{{ 'Password' | translate }}</span>
              <p *ngIf="checkPassword" class="error-require">{{ messageCheckPassword }}</p>
            </div>
            <div class="field-button">
              <button type="submit">{{ 'Sign In' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bg-popup"></div>